module.exports = __webpack_public_path__ + "img/vegan.4b04cff7.svg";